<template>
  <v-tabs>
    <v-tab><h2>瀏覽</h2></v-tab>
    <v-tab-item class="pa-1 pa-sm-4">
      <!-- Save & Reset Buttons -->
      <v-row>
        <v-col sm="12" md="9" class="pb-0 pt-0 text-end">
          <v-btn
            class="ma-2"
            elevation="4"
            color="success"
            @click="handleOnNewAddOne"
          >
            <v-icon>mdi-plus-thick</v-icon>
          </v-btn>
          <v-btn
            class="ma-2"
            elevation="4"
            color="error"
            @click="handleOnDeleteAddOne"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <!-- Table -->
      <v-row>
        <v-col sm="12" md="9" class="pb-0 pt-0">
          <v-data-table
            :headers="headers"
            item-key="user"
            :items="!isSending ? admins : []"
            class="elevation-4 my-admin-table"
            :search="tableSearch"
            :loading="isSending"
            loading-text="資料更新中..."
            no-data-text="暫無資料"
            show-select
            v-model="tableCBSelected"
            :mobile-breakpoint="tableModes[tableMode].breakpoint"
          >
            <template v-slot:item.actions="{ item }">
              <v-icon class="mr-2" @click="handleOnEditAddOne(item)">
                mdi-pencil
              </v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-tab-item>
    <!-- Dialog -->
    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h3>{{ dialogMode ? '新增帳號' : '編輯帳號' }}</h3>
        </v-card-title>
        <!--  -->
        <v-card-text>
          <v-form
            ref="admin-form"
            v-model="dialogInputValid"
            @submit.prevent=""
          >
            <v-text-field
              v-model="user"
              label="帳號"
              :rules="dialogInputRules"
              :counter="40"
              @keydown.space.prevent=""
              required
            ></v-text-field>
            <v-text-field
              v-model="pass"
              label="密碼"
              :counter="20"
              :rules="dialogInputRules"
              :type="showPassword ? 'text' : 'password'"
              :append-icon="showPassword ? 'visibility' : 'visibility_off'"
              @click:append="showPassword = !showPassword"
              @keydown.space.prevent=""
              required
            ></v-text-field>
            <v-switch
              v-model="userEnb"
              inset
              color="primary"
              :label="`狀態:${userEnb ? '啟用' : '關閉'}`"
            ></v-switch>
          </v-form>
        </v-card-text>
        <!--  -->
        <v-card-actions>
          <v-row>
            <v-col>
              <v-btn elevation="4" color="error" @click="dialog = false">
                <v-icon>mdi-close-thick</v-icon>
              </v-btn>
            </v-col>
            <v-col class="text-end">
              <v-btn
                elevation="4"
                color="success"
                @click="handleOnDialogSave"
                :disabled="isSending"
              >
                <v-icon>mdi-check-bold</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
        <!--  -->
        <v-progress-linear
          :active="isSending"
          indeterminate
          absolute
          bottom
        ></v-progress-linear>
      </v-card>
    </v-dialog>
  </v-tabs>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  data: () => ({
    // Dialog
    dialog: false,
    dialogInputValid: false,
    dialogMode: true,
    dialogOnSaveFn: undefined,
    dialogInputRules: [
      v => !!v || '不可空白',
      v => v.length <= 30 || '不可超過30個字',
      v => v.length > 5 || '不可少於6個字'
    ],
    showPassword: false,
    user: '',
    pass: '',
    userEnb: true,
    // Table
    tableSearch: '',
    tableCBSelected: [],
    headers: [
      {
        text: '帳號',
        align: 'start',
        value: 'user'
      },
      {
        text: '密碼',
        align: 'start',
        value: 'pass'
      },
      {
        text: '登入時間',
        align: 'start',
        value: 'login_time'
      },
      {
        text: '',
        align: 'start',
        value: 'actions'
      }
    ]
    //
  }),
  computed: {
    ...mapState('account', ['uid', 'level']),
    ...mapState('admin', ['tableModes', 'tableMode', 'isSending', 'admins'])
  },
  methods: {
    ...mapActions('admin', [
      'addAdmin',
      'getAllAdmins',
      'updateAdmin',
      'deleteAdmin'
    ]),
    handleOnNewAddOne() {
      this.user = ''
      this.pass = ''
      this.userEnb = true
      this.dialog = true
      this.$nextTick(() => {
        if (!this.dialogInputValid) this.$refs['admin-form'].resetValidation()
      })
      this.dialogOnSaveFn = async () => {
        if (!this.$refs['admin-form'].validate()) return
        // if (!this.dialogInputValid) return
        const { user, pass, uid, level } = this
        await this.addAdmin({
          uid,
          user,
          pass,
          level,
          enb: this.userEnb ? 1 : 0
        })
        this.dialog = false
      }
    },
    handleOnEditAddOne(item) {
      this.user = item.user
      this.pass = item.pass
      this.userEnb = item.enb
      this.dialog = true
      this.dialogOnSaveFn = async () => {
        if (!this.user || !this.pass) return
        const { user, pass, uid, level } = this
        await this.updateAdmin({
          uid,
          id: item.id,
          user,
          pass,
          level,
          enb: this.userEnb ? 1 : 0
        })
        this.dialog = false
      }
    },
    handleOnDeleteAddOne() {
      if (this.tableCBSelected.length < 1) return
      if (!confirm('確定刪除嗎?')) return
      const ids = []
      this.tableCBSelected.forEach(e => {
        ids.push(e.id)
      })
      const { uid, level } = this
      this.deleteAdmin({
        uid,
        ids,
        level
      })
    },
    // Dialog
    handleOnDialogSave() {
      if (this.dialogOnSaveFn) this.dialogOnSaveFn()
    }
  },
  created() {
    this.$emit('setTopLabel', 7)
    //
    ;(async () => {
      const { uid } = this
      await this.getAllAdmins({ uid, level: this.level })
    })()
  },
  mounted() {}
}
</script>

<style lang="scss">
.my-admin-table {
  th,
  td {
    font-size: 18px;
  }
}

@media screen and (max-width: 600px) {
  .my-admin-table {
    .v-input {
      label,
      input {
        font-size: 20px;
      }
    }

    th,
    td {
      padding-right: 2px !important;
      padding-left: 4px !important;
    }

    .v-data-footer {
      .v-data-footer__select {
        margin-right: 0px;
      }
    }
  }
}
</style>
